import { MyMscExcursion } from '@msc-b2c/interfaces/interfaces';
import { CruiseDay } from '@msc-b2c/interfaces/types';

export const findFirstExcursionForDay = (day: CruiseDay, excursions: MyMscExcursion[]) => {
  // Find excursions that match the day (matching by portCode and date)
  const matchingExcursions = excursions.filter((excursion) => excursion.startDate === day.date);

  // Return the first matching excursion, or undefined if no match found
  return matchingExcursions.length > 0 ? matchingExcursions[0] : undefined;
};
